import './styles.css';

const Error = (props) => {
  return <div>404 Page</div>
}

export default Error;
